module.exports = __webpack_public_path__ + "static/title.d28b26c1.png";